import React from 'react';

function SolomonIslands(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124007)">
        <mask
          id="mask0_800_124007"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124007)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#3D58DB"
          />
          <mask
            id="mask1_800_124007"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124007)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 24H36V0L0 24Z"
              fill="#579D20"
            />
            <path
              d="M-0.879718 24.7453L-2.90894 22.2492L37.8846 -1.95432L39.9138 0.541773L-0.879718 24.7453Z"
              fill="#FECA00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.11007 6.54657L5.64409 5.60077L7.25061 6.45095L6.68793 4.92664L7.81146 3.83588H6.28922L5.64409 2.23401L4.99896 3.83588L3.47412 3.89183L4.60025 4.92664L4.11007 6.54657ZM10.4756 6.54657L12.0096 5.60077L13.6161 6.45095L13.0534 4.92664L14.177 3.83588H12.6547L12.0096 2.23401L11.3645 3.83588L9.83961 3.89183L10.9657 4.92664L10.4756 6.54657Z"
              fill="#F7FCFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.47918 9.45452L9.0132 8.50873L10.6197 9.35891L10.057 7.8346L11.1806 6.74383H9.65833L9.0132 5.14197L8.36807 6.74383L6.84323 6.79979L7.96936 7.8346L7.47918 9.45452ZM5.64409 11.6008L4.11007 12.5466L4.60025 10.9266L3.47412 9.89182L4.99896 9.83587L5.64409 8.234L6.28922 9.83587H7.81146L6.68793 10.9266L7.25061 12.4509L5.64409 11.6008ZM12.0096 11.6008L10.4756 12.5466L10.9657 10.9266L9.83961 9.89183L11.3645 9.83588L12.0096 8.23401L12.6547 9.83588H14.177L13.0534 10.9266L13.6161 12.451L12.0096 11.6008Z"
              fill="#F7FCFF"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124007">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SolomonIslands;
